var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"error"},[_c('UiBaseIcon',{staticClass:"error-icon",attrs:{"icon-name":"exclamation","width":"11px","height":"11px"}}),_c('span',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.error)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }